module.exports = __webpack_public_path__ + "img/euro.55ddbb66.jpg";